import React, { Component, PropTypes } from 'react';
import { throttle } from 'lodash';
import './teamNames.scss';

export default class TeamNames extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    setTeamName: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    presenter: PropTypes.bool,
    i18n: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);
    this.throttledSetTeamName = {};
    [1, 2, 3, 4].forEach(teamNumber => {
      this.throttledSetTeamName[teamNumber] = throttle(
        this.setTeamName.bind(this, teamNumber),
        3000
      );
    });
    this.state = {
      optimisticUpdates: {
        '1': null,
        '2': null,
        '3': null,
        '4': null
      }
    };
  }

  componentDidMount() {
    this.refs.team1.focus();
  }

  componentWillReceiveProps (nextProps, nextContext) {
    const { session } = this.context;
    const { teamNames } = session;
    const { session: nextSession } = nextContext;
    const { teamNames: nextTeamNames } = nextSession;
    const { optimisticUpdates } = this.state;
    [1, 2, 3, 4].forEach(teamNumber => {
      if (teamNames && nextTeamNames[teamNumber] !== teamNames[teamNumber]) {
        optimisticUpdates[teamNumber] = null;
        this.setState({ optimisticUpdates });
      }
    });
  }

  setTeamName (teamNumber, value) {
    const { setTeamName, hideHUD } = this.context;
    setTeamName(teamNumber, value);
    hideHUD();
  }

  clickHandler (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  changeHandler (evt) {
    const match = evt.target.name.match(/team(\d+)$/);
    if (match && match[1]) {
      const teamNumber = Number(match[1]);
      const { optimisticUpdates } = this.state;
      optimisticUpdates[teamNumber] = evt.target.value;
      this.setState({ optimisticUpdates });
      this.throttledSetTeamName[teamNumber](evt.target.value);
    }
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  keyDown (evt) {
    const { presenter } = this.context;
    if (evt) {
      if (presenter) {
        // Stop arrow key navigation on teacher remote
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.stopPropagation();
          evt.nativeEvent.stopPropagation();
        }
      } else {
        // Don't use arrows for input fields in presentation mode
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.preventDefault();
        }
      }
    }
  }

  render () {
    const { session, i18n: _ } = this.context;
    const { teamNames } = session;
    const { optimisticUpdates } = this.state;
    const optimisticTeamNames = {};
    [1, 2, 3, 4].forEach(teamNumber => {
      let teamName = null;
      if (optimisticUpdates[teamNumber] !== null) {
        teamName = optimisticUpdates[teamNumber];
      } else {
        teamName = teamNames && teamNames[teamNumber];
      }
      optimisticTeamNames[teamNumber] = teamName;
    });

    return (
      <div className="team-names">
        <div className="form-group team-1">
          <label className="control-label">{_('Earth')}<i className="ppa-icon ppa-icon-team-1"></i></label>
          <input
              className="form-control"
              placeholder={_('(Pick an Earth-related team name)')}
              name="team1"
              ref="team1"
              value={optimisticTeamNames[1]}
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown} />
        </div>
        <div className="form-group team-2">
          <label className="control-label">{_('Fire')}<i className="ppa-icon ppa-icon-team-2"></i></label>
          <input
              className="form-control"
              placeholder={_('(Pick a Fire-related team name)')}
              name="team2"
              value={optimisticTeamNames[2]}
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown} />
        </div>
        <div className="form-group team-3">
          <label className="control-label">{_('Water')}<i className="ppa-icon ppa-icon-team-3"></i></label>
          <input
              className="form-control"
              placeholder={_('(Pick a Water-related team name)')}
              name="team3"
              value={optimisticTeamNames[3]}
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown} />
        </div>
        <div className="form-group team-4">
          <label className="control-label">{_('Air')}<i className="ppa-icon ppa-icon-team-4"></i></label>
          <input
              className="form-control"
              placeholder={_('(Pick an Air-related team name)')}
              name="team4"
              value={optimisticTeamNames[4]}
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown} />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/teamNames.js